import { render } from "./wechatCardMessage.vue?vue&type=template&id=1d0c1a9a&scoped=true"
import script from "./wechatCardMessage.vue?vue&type=script&lang=js"
export * from "./wechatCardMessage.vue?vue&type=script&lang=js"

import "./wechatCardMessage.vue?vue&type=style&index=0&id=1d0c1a9a&lang=scss&scoped=true"

import exportComponent from "D:\\workspace\\front\\syb\\syb_webchat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d0c1a9a"]])

export default __exports__